/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vp_Blocked_Override_BtnInputs */



/**
* | output |
* | --- |
* | "Override as judge" |
*
* @param {Vp_Blocked_Override_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vp_blocked_override_btn = /** @type {((inputs?: Vp_Blocked_Override_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vp_Blocked_Override_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier en tant qu'arbitre")
	if (locale === "es") return /** @type {LocalizedString} */ ("Anular como juez")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Substituir como juiz")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sovrascrivi come giudice")
	return /** @type {LocalizedString} */ ("Override as judge")
});